<template>
  <div class="CreateOrJoin column fullWidth">
    <div class="column fullWidth">
      <div class="row alignCentreRow justifyToCentre">
        <UnitButton
          v-if="!userInStore.loggedIn"
          variant="secondary"
          @click="toggleLoginModal"
          v-haptic
        >
          Login
        </UnitButton>
        <span v-if="!userInStore.loggedIn">or</span>
        <UnitButton
          v-if="!userInStore.loggedIn"
          variant="secondary"
          @click="toggleRegisterModal"
          v-haptic
        >
          Register
        </UnitButton>
        <HelpHint
          v-if="!userInStore.loggedIn"
          :message="`When you create your currency with us you automatically create your organisation. Since coins and organisations come hand-in-hand, the term 'unit' can apply to both the coin and its founding organisation.`"
          icon="What's a unit?"
          size="large"
          class="create-or-join__explainer"
        />
      </div>
      <h2 class="shortwidth alignCentre nomargintopbottom">
        Create an organisation
      </h2>
      <div class="column fullWidth alignCentre">
        <UnitButton @click="openOrganisationCreation" v-haptic>
          Create organisation
        </UnitButton>
      </div>
    </div>
    <p class="or">or</p>

    <section>
      <div class="column secondSection">
        <div class="column alignCentre">
          <p class="shortwidth nomargintopbottom">
            Use an invite link to join a specific organisation to start trading.
          </p>
        </div>
        <UseInviteLink />
      </div>
    </section>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

import HelpHint from "@/components/GenericComponents/HelpHint.vue";
import UseInviteLink from "@/components/LandingComponents/UseInviteLink.vue";
import UnitButton from "@/components/GenericComponents/UnitButton.vue";

export default {
  name: "CreateOrJoin",
  components: {
    HelpHint,
    UseInviteLink,
    UnitButton,
  },
  props: {
    user: Object, // Accept the prop
  },

  setup() {
    const store = useStore();
    const router = useRouter(); // Using the Vue Router
    const windowWidth = ref(window.innerWidth);
    const userInStore = computed(() => store.getters.user);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    let foundationOrgUID = store.getters.foundationOrgUID;
    const orgDetails = computed(() =>
      store.getters.getBasicOrgDetails(foundationOrgUID)
    );

    const orgMembers = computed(() => store.getters.getMembers);

    // Define the functions to redirect

    // modals logic
    const toggleLoginModal = () => store.dispatch("toggleLoginModal");
    const toggleRegisterModal = () => store.dispatch("toggleRegisterModal");
    const openOrganisationCreation = () => {
      if (userInStore.value.loggedIn) {
        router.push({ name: "organisation-new" });
        return;
      }
      router.push({
        name: "Register",
        query: { returnTo: "/organisations/new" },
      });
    };

    onMounted(async () => {
      window.addEventListener("resize", handleResize);
      await store.dispatch("fetchAllData", foundationOrgUID);
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    return {
      userInStore,
      windowWidth,
      toggleLoginModal,
      toggleRegisterModal,
      orgDetails,
      orgMembers,
      openOrganisationCreation,
      foundationOrgUID,
    };
  },
};
</script>

<style scoped>
.Wallet .LandingElement {
  position: relative;
  width: 100%;
}

.Wallet .LandingElement section {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-5);
}
.LandingElement {
  width: 100%;
  height: 60vh;
  left: 0;
  top: 0;
  padding: var(--space-5);

  background-image: url("@/assets/stockImg/local_market_phone.jpg");
  background-size: cover;
  background-position: center;
}

.theCard {
  margin-top: calc(var(--control-height-default) + calc(var(--space-4) * 2));
}

.CreateOrJoin {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.create-or-join__explainer {
  background: transparent;
  box-shadow: none;
}

.create-coin-surface {
  background: var(--color-feedback-success-surface-subtle);
}
.secondSection {
  align-items: center;
}

.regularColumns .column {
  max-width: 33%;
  gap: var(--space-4);
}

@media only screen and (max-width: 490px) {
  .LandingElement {
    height: 60vh;
  }
  .secondSection {
    /* margin-top: 60vh; */
  }
}

@media only screen and (max-width: 590px) {
  .LandingElement {
    height: 60vh;
  }
  .secondSection {
    /* margin-top: 60vh; */
  }

  .regularColumns .column {
    width: 100%;
    max-width: 100%;
  }
}
</style>
